import { JobGetRequest, JobListRequest } from '#/protobuf/service_query_pb';
import { JobInfoQueryExpansionRequest } from '#/protobuf/job_pb';
import { EntityInfoExpansionRequest } from '#/protobuf/entity_pb';

export const DEFAULT_PAGE_SIZE = 15;

function FreshEntityDownloadRequest() {
  // we want downloads for our reports
  const downloadRequest = new EntityInfoExpansionRequest();
  downloadRequest.setRequestDownloads(true);
  return downloadRequest;
}

function FreshJobInfoQueryExpansionRequest() {
  const jobInfoRequest = new JobInfoQueryExpansionRequest();

  // we want downloads for our reports
  jobInfoRequest.setShouldExpandReports(new FreshEntityDownloadRequest());
  // we want downloads for our key entity
  jobInfoRequest.setShouldExpandKeyEntity(new FreshEntityDownloadRequest());

  jobInfoRequest.setShouldExpandTags(true);
  jobInfoRequest.setShouldExpandTasks(true);

  return jobInfoRequest;
}

// export function FreshJobListRequest() {
//   const request = new JobListRequest();
//   request.setCursor(0);
//   request.setLimit(DEFAULT_PAGE_SIZE);
//   const jobExpansion = FreshJobInfoQueryExpansionRequest();
//   // for list we explicitly want to disable job folder expansion for memory reasons
//   // note: the backend will throw an error code 9 if this is flipped to true on list
//   jobExpansion.setShouldExpandJobFolders(false);
//   request.setExpansionRequest();
//
//   // const searchParams = this.searchParameters();
//   // if (searchParams !== null) {
//   //   request.setSearchTerms(searchParams);
//   // }
//   return request;
// }

export function FreshJobListRequest() {
  const request = new JobListRequest();
  request.setCursor(0);
  request.setLimit(DEFAULT_PAGE_SIZE);
  const expansion = new JobInfoQueryExpansionRequest();
  expansion.setShouldExpandReports(FreshEntityDownloadRequest());
  expansion.setShouldExpandKeyEntity(FreshEntityDownloadRequest());
  expansion.setShouldExpandJobFolders(false); // THIS IS EXPLICITLY SET TO FALSE ON LIST
  expansion.setShouldExpandTags(true);
  expansion.setShouldExpandVolumeMapping(true);
  expansion.setShouldExpandTasks(true);
  expansion.setShouldExpandMediaDerivatives(true);
  request.setExpansionRequest(expansion);
  return request;
}

export function FreshJobGetRequest(jobIds) {
  if (!jobIds || jobIds.length === 0) {
    throw (new Error('cannot create job get request without list of job ids.'));
  }
  const request = new JobGetRequest();
  request.addJobIds(jobIds);
  const expansion = new JobInfoQueryExpansionRequest();
  expansion.setShouldExpandReports(FreshEntityDownloadRequest());
  expansion.setShouldExpandKeyEntity(FreshEntityDownloadRequest());
  expansion.setShouldExpandJobFolders(true);
  expansion.setShouldExpandTags(true);
  expansion.setShouldExpandVolumeMapping(true);
  expansion.setShouldExpandTasks(true);
  expansion.setShouldExpandMediaDerivatives(true);
  request.setExpansionRequest(expansion);
  return request;
}
